import { Observable } from 'rxjs';
import { BaseService } from '../base.service';
import { MasterConfig, MasterConfigParams } from '../../interfaces/master-config.interface';
import { PageResponse } from '../../interfaces/page-response.interface';
import { CommonSearchParam } from '../../interfaces/common-search-param.interface';

export abstract class MasterConfigService extends BaseService<MasterConfig> {
  abstract getConfigMaster(params: MasterConfigParams): Observable<PageResponse<MasterConfig>>;

  // BaseService methods to be implemented by child classes
  abstract override findAll(commonSearchParam: CommonSearchParam): Observable<PageResponse<MasterConfig>>;
  abstract override find(id: string): Observable<MasterConfig>;
  abstract override create(data: Partial<MasterConfig>): Observable<MasterConfig>;
  abstract override update(id: string, data: Partial<MasterConfig>): Observable<MasterConfig>;
  abstract override delete(id: string): Observable<void>;
}
